import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CartSheet from "./CartSheet";
import AnnouncementBar from "./AnnouncementBar";
import FloatingWhatsApp from "./FloatingWhatsApp";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col grain relative">
      <AnnouncementBar />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartSheet />
      <FloatingWhatsApp />
    </div>
  );
}
